/**
 * Formats a URL slug into a display-friendly string
 * @param slug - The URL slug to format (e.g., "electronics", "home-appliances")
 * @returns Formatted string (e.g., "Electronics", "Home Appliances")
 * 
 * @example
 * formatSlug("electronics") // Returns "Electronics"
 * formatSlug("home-appliances") // Returns "Home Appliances"
 * formatSlug("smart-phones") // Returns "Smart Phones"
 */
export function formatSlug(slug: string): string {
  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

/**
 * Converts a display name back to a URL-safe slug
 * @param name - The display name to convert (e.g., "Electronics", "Home Appliances")
 * @returns URL-safe slug (e.g., "electronics", "home-appliances")
 * 
 * @example
 * slugify("Electronics") // Returns "electronics"
 * slugify("Home Appliances") // Returns "home-appliances"
 */
export function slugify(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-");
}

